
import * as modals from "../../../lib/modals";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import ModalMixin from "./mixin";
import PalletHeader from "@/components/barcodeSystem/inventory/PalletHeader.vue";
import PalletItemTable from "@/components/barcodeSystem/inventory/PalletItemTable.vue";
import notifications from "@/lib/notifications";
import PalletOrderTable from "@/components/barcodeSystem/inventory/PalletOrderTable.vue";
import InventoryTransactionTable from "@/components/barcodeSystem/inventory/InventoryTransactionTable.vue";
import { PalletResource } from "@/models/api/barcodeSystem/inventory/pallets";

const inventoryModuleState = getModule(InventoryModule);

@Component({
  name: modals.palletViewModal,
  components: {
    PalletHeader,
    PalletItemTable,
    PalletOrderTable,
    InventoryTransactionTable
  }
})
export default class PalletViewModal extends ModalMixin {
  loadingComplete: boolean = false;
  tabIsLoading: boolean = false;
  loadedTabs: string[] = [];
  loadingTransactions: boolean = false;
  showTransLogsModal: boolean = false;

  async load() {
    this.loadingComplete = false;
    this.show();
    try{
      await inventoryModuleState.loadPallet(this.selectedItem.id);
    } catch (ex) {
      notifications.error("Failed to load pallet", "Failed to load pallet", ex);
      this.hideModal();
    }
    this.loadingComplete = true;
    this.loadTab("palletItems");
  }

  get currentPallet() : PalletResource
  {
    return inventoryModuleState.currentPallet;
  }

  get orderItemCount() : number
  {
    if(inventoryModuleState.palletItemsData)
      return inventoryModuleState.palletItemsData.length;
    return 0
  }

  tabHasBeenLoaded(title: string): boolean {
    return this.loadedTabs.indexOf(title) > -1;
  }

  loadTab(title: string) {
    if (this.tabHasBeenLoaded(title)) {
      return;
    }

    let action = null;

    switch (title) {
      case "palletItems":
        action = inventoryModuleState.loadPalletItems;
        break;
      case "orders":
        action = inventoryModuleState.loadPalletOrders;
        break;
    }
    if (action) {
      this.tabIsLoading = true;
      action()
      .catch((error) => {
        notifications.error("Error loading tab", `Failed to load ${title} tab.`, error);
      })
      .finally(() => {
        this.loadedTabs.push(title);
        this.tabIsLoading = false;
      });
    }
  }

  async showTransLog(){
    if(this.currentPallet)
    {
      this.loadingTransactions = true;
      this.showTransLogsModal=true;
      try {
        await inventoryModuleState.getInventoryTransactionsForPallet();
      } catch (error) {
        notifications.error(
          "Pallet Transactions Failed",
          error.response.data.message
        );
      }   
      finally{
        this.loadingTransactions = false;
      }
    }
  }

  closeModals()
  {
    this.showTransLogsModal=false;
  }

  reset() {
    this.loadingComplete = false;
    this.tabIsLoading = false;
    this.loadedTabs = [];
  }
}
